import { Link } from './Link';
import { Button } from '@presov.sk/presov-ui-react';
import React from 'react';

type ButtonProps = React.ComponentProps<typeof Button>;

export type LinkButtonProps = Omit<ButtonProps, 'href'> & {
  /** Cieľ v aplikácii. Routuje `react-router`, adresu vidno v stavovom riadku. */
  to: string;
  target?: string;
};

/**
 * Tlačidlo, ktoré vedie na adresu - teda skutočný `<a href>`.
 *
 * Existuje z dvoch dôvodov naraz. Prvý je pravidlo z [[shell]]: cieľ, ktorý má
 * adresu, sa nezapisuje ako `onClick: () => navigate(...)`, lebo taký cieľ sa
 * nedá otvoriť cmd/ctrl klikom ani skopírovať. Druhý je typový: `Button`
 * z knižnice je `React.FC<Props>`, takže mu prepadli generiká MUI-ovského
 * `OverridableComponent` a `component`/`to` cezeň neprejdú. Pretypovanie je
 * preto tu, na jednom mieste, namiesto `as any` pri každom tlačidle.
 */
const LinkButton: React.FC<LinkButtonProps> = ({ to, target, ...props }) => (
  <Button
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {...({ component: Link, to, target } as any)}
    {...props}
  />
);

export default LinkButton;
